import { Outlet } from 'react-router-dom';

/**
 * Outermost routed layout. App-wide providers live above the router (in
 * `AppProviders`), so this layout is a thin shell — a stable seam for elements
 * that must sit inside the router context (scroll restoration, route
 * transitions, breadcrumbs) as the app grows.
 */
export function RootLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-background text-foreground">
      <Outlet />
    </div>
  );
}
